// Bug/Task/Change-Request pipeline layered on top of Chatwoot's native
// Open/Pending/Resolved status. Every non-resolved stage stays native
// "open" (see Conversations::WorkflowStageService), so this mapping is
// the only place stage progress is actually visible to agents — used by
// the per-conversation stage button, the list-row icon, and the list-row
// label so the wording stays identical everywhere.

export const WORKFLOW_TYPE_LABEL = { bug: 'Bug', task: 'Task', change_request: 'CR' };

export const WORKFLOW_STAGE_META = {
  open: {
    icon: 'i-lucide-inbox',
    badgeClass: 'bg-n-amber-3 text-n-amber-11',
    suffix: 'New — Awaiting Triage',
    urgent: true,
    skipTypePrefix: true,
  },
  assigned_qa: {
    icon: 'i-lucide-search',
    badgeClass: 'bg-n-blue-3 text-n-blue-11',
    suffix: 'With QA — Reviewing',
  },
  qa_confirmed_bug: {
    icon: 'i-lucide-circle-alert',
    badgeClass: 'bg-n-ruby-3 text-n-ruby-11',
    suffix: 'QA Confirmed Bug — Awaiting Developer',
    urgent: true,
  },
  qa_rejected: {
    icon: 'i-lucide-circle-slash',
    badgeClass: 'bg-n-slate-4 text-n-slate-11',
    suffix: 'Not a Bug — Awaiting Admin',
    urgent: true,
    skipTypePrefix: true,
  },
  assigned_dev: {
    icon: 'i-lucide-user-round',
    badgeClass: 'bg-n-blue-3 text-n-blue-11',
    suffix: 'Assigned to Developer — Not Started',
  },
  in_progress: {
    icon: 'i-lucide-hammer',
    badgeClass: 'bg-n-amber-3 text-n-amber-11',
    suffix: 'In Progress',
  },
  to_be_tested: {
    icon: 'i-lucide-flask-conical',
    badgeClass: 'bg-n-ruby-3 text-n-ruby-11',
    suffix: 'To Be Tested — Awaiting QA Approval',
    urgent: true,
  },
  resolved: {
    icon: 'i-lucide-circle-check',
    badgeClass: 'bg-n-teal-3 text-n-teal-11',
    suffix: 'Resolved',
    skipTypePrefix: true,
  },
};

export function getWorkflowStageMeta(stage) {
  return WORKFLOW_STAGE_META[stage] || WORKFLOW_STAGE_META.open;
}

export function getWorkflowStageLabel(stage, type) {
  const meta = getWorkflowStageMeta(stage);
  if (meta.skipTypePrefix) return meta.suffix;
  const typeLabel = WORKFLOW_TYPE_LABEL[type] || 'Bug';
  return `${typeLabel} — ${meta.suffix}`;
}
